import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Visit } from '../../models/visit.model';
import { VisitActions } from './visits.actions';

export interface VisitsState extends EntityState<Visit> {
  loading: boolean;
  error: string | null;
}

export const adapter = createEntityAdapter<Visit>();

const initialState: VisitsState = adapter.getInitialState({
  loading: false,
  error: null,
});

export const visitsFeature = createFeature({
  name: 'visits',
  reducer: createReducer(
    initialState,
    on(VisitActions.loadVisits, (state) => ({ ...state, loading: true, error: null })),
    on(VisitActions.loadVisitsSuccess, (state, { visits }) =>
      adapter.setAll(visits, { ...state, loading: false })),
    on(VisitActions.loadVisitsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    on(VisitActions.loadVisitSuccess, (state, { visit }) => adapter.upsertOne(visit, state)),
    on(VisitActions.createVisitSuccess, (state, { visit }) => adapter.addOne(visit, state)),
    on(VisitActions.startVisitSuccess, (state, { visit }) => adapter.upsertOne(visit, state)),
    on(VisitActions.completeVisitSuccess, (state, { visit }) => adapter.upsertOne(visit, state)),
    on(VisitActions.cancelVisitSuccess, (state, { visit }) => adapter.upsertOne(visit, state)),
    on(VisitActions.skipVisitSuccess, (state, { visit }) => adapter.upsertOne(visit, state)),
    on(VisitActions.visitFailure, (state, { error }) => ({ ...state, error })),
  )
});

export const {
  name: visitsFeatureKey,
  reducer,
  selectVisitsState,
  selectLoading: selectVisitsLoading,
  selectError: selectVisitsError,
} = visitsFeature;

export const { selectAll, selectEntities } = adapter.getSelectors();
